// src/components/skeletons/ProductSkeleton.js
import React from 'react';
import './ProductSkeleton.css';

const ProductSkeleton = () => {
  return (
    <div className="productdetail-skeleton">
      <div className="productdetail-skeleton-header" />
      <div className="productdetail-skeleton-carousel" />
      <div className="productdetail-skeleton-info">
        <div className="skeleton-line wide" />
        <div className="skeleton-line" />
        <div className="skeleton-line" />
        <div className="skeleton-line" />
        <div className="skeleton-line short" />
      </div>
    </div>
  );
};

export default ProductSkeleton;
